// Modules
import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router';

// Services
import Person from 'services/data/person';

// Actions
import { alerts } from 'modules/alerts/actions';

// Components
import { SVGButton } from 'components/widgets/buttons/buttons';
import FormPopover from 'components/widgets/overlays/form';
import PersonForm from 'components/models/person/person-form';
import SVG from 'components/widgets/icons/svg';


// Component
export default class PersonEdit extends React.Component {
  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    const create = _.clone(values);

    return Person.create(create)
      .then(person =>
        alerts.success({
          title: `${person.firstName} ${person.lastName} added!`,
          subtitle: <Link to={`/people/${person.id}/summary`}>View person</Link>
        })
      )
      .then(this.addForm.toggle)
      .catch(alerts.catchError);
  }

  render() {
    return (
      <div className="add-person">
        <FormPopover
          target={<SVGButton src="svg/add.svg" className="add-item-link" />}
          title="Add Person"
          popoverClassName="person-form"
          ref={(el) => { this.addForm = el; }}
        >
          <div>
            <div className="form-header">
              <SVG src="svg/company.svg" className="company" />
              <h5 className="form-title">Add Person</h5>
              <SVG onClick={() => this.addForm.toggle()} className="close" src="svg/close.svg" />
            </div>
            <PersonForm
              onSubmit={this.onSubmit}
              form="personForm-new"
              quickAdd
            />
          </div>
        </FormPopover>
      </div>
    );
  }
}
